export default "__VITE_ASSET__A17oxWpE__"